<template>
	<BFormCheckbox
		:checked="!shippingDifferentFromBilling"
		@change="setShippingDifferentFromBilling(!shippingDifferentFromBilling)"
	>
		Shipping is the same as billing
	</BFormCheckbox>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { BFormCheckbox } from 'bootstrap-vue';

export default {
	components: {
		BFormCheckbox,
	},

	computed: mapState('checkout', ['shippingDifferentFromBilling']),

	methods: mapMutations('checkout', ['setShippingDifferentFromBilling']),
};
</script>
